const parser = require('./parser');
const validation = require('./validation');

class MessageHandler {
    constructor(errorResponses) {
        this._errorResponses = errorResponses;
        this._requestHandlers = {};
    }

    onRequest(req, handler) {
        this._requestHandlers[req] = handler;
    }

    unpackMessage(message) {
        var data = parser.parseJsonSafely(message);
        
        if (data == null)
            return {
                result: false,
                errorResponse: this._errorResponses.invalidMessageFormat,
                isResponse: false,
                data: null
            };

        if (data.hasOwnProperty('result')) {
            if (!data.hasOwnProperty('req_id') || !validation.isInteger(data.req_id))
                return {
                    result: false,
                    errorResponse: null,
                    isResponse: true,
                    data: null
                };

            return {
                result: true,
                errorResponse: null,
                isResponse: true,
                data: data
            }
        }

        return {
            result: true,
            errorResponse: null,
            isResponse: false,
            data: data
        }
    }

    async handleRequest(data, options) {
        if (!data.hasOwnProperty('req'))
            return this._errorResponses.missingFieldReq;

        if (!data.hasOwnProperty('req_id'))
            return this._errorResponses.missingFieldReqId;

        if (!validation.isInteger(data.req_id))
            return this._errorResponses.invalidFieldReqIdType;

        if (!this._requestHandlers.hasOwnProperty(data.req)) {
            this._errorResponses.invalidReq.req_id = data.req_id;
            this._errorResponses.invalidReq.message = 'Request type "' + data.req + '" is invalid.';
            return this._errorResponses.invalidReq;
        }

        return await this._requestHandlers[data.req](data, options);          
    }
}

export default MessageHandler;